/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_End_OtherInputs */

const en_us2_offline_end_other = /** @type {(inputs: Offline_End_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End the other and sync this one`)
};

const pt_br2_offline_end_other = /** @type {(inputs: Offline_End_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encerrar o outro e sincronizar este`)
};

const es_419_offline_end_other = /** @type {(inputs: Offline_End_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar el otro y sincronizar este`)
};

const pt_pt2_offline_end_other = /** @type {(inputs: Offline_End_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar o outro e sincronizar este`)
};

const fr_fr2_offline_end_other = /** @type {(inputs: Offline_End_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminer l'autre et synchroniser celle-ci`)
};

const de_de2_offline_end_other = /** @type {(inputs: Offline_End_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anderes beenden, dieses synchronisieren`)
};

const it_it2_offline_end_other = /** @type {(inputs: Offline_End_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi l'altro e sincronizza questo`)
};

/**
* | output |
* | --- |
* | "End the other and sync this one" |
*
* @param {Offline_End_OtherInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_end_other = /** @type {((inputs?: Offline_End_OtherInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_End_OtherInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_end_other(inputs)
	if (locale === "es-419") return es_419_offline_end_other(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_end_other(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_end_other(inputs)
	if (locale === "de-DE") return de_de2_offline_end_other(inputs)
	if (locale === "it-IT") return it_it2_offline_end_other(inputs)
	return en_us2_offline_end_other(inputs)
});
export { offline_end_other as "offline.end_other" }